import React from 'react';
import { Row, Col } from 'react-bootstrap';
import { SearchBox } from 'fw/forms';
import { Button } from 'fw/components';
import { SetupSearch } from 'areas/shared/pages/setup';
import * as API from 'modules/app/API';
import APIDownload from 'fw/system/API';
import * as Notifications from 'fw/globals/Notifications';

class Search extends SetupSearch {

    initialState() {
        return {
            list: [],
            loading: false,
        };
    }

    initialForm() {
        API.Biz.post('/vobSetup/getSupplierList', null,
            {
                success: (r) => {
                    this.setState(
                        {
                            supplierListStorageKey: r.data.supplierListStorageKey,
                            supplierListFileName: r.data.supplierListFileName
                        }
                    );
                },
                error: (r) => {
                    Notifications.error(r.error.errorMessage);
                }
            });
        return {
            sponsorName: "",
        };
    }

    ready = () => {
        this.setState({
            isReady: true
        });
        this.focusControl && this.focusControl.focus();
    }

    searchSponsorLoader = () => {
        return {
            url: API.Search.url('/suggest'),
            params: { type: 'sponsor' }
        }
    }

    download = () => {
        new APIDownload().download({
            storageToken: this.state.supplierListStorageKey,
            fileName: this.state.supplierListFileName,
        });
    };

    renderForm() {
        return (
            <React.Fragment>
                <Row>
                    <br />
                    <Col md={6}>
                        <SearchBox
                            name='sponsorName'
                            label='sponsorName'
                            placeholder='Company Name'
                            loader={this.searchSponsorLoader}
                            ref={(c) => { this.focusControl = c }} />
                        <br />
                    </Col>
                    <Col md={2}>
                        {this.state.isReady && this.state.supplierListStorageKey !== null ? (
                            <React.Fragment>
								<Button type="button" bsStyle="link" onClick={this.download} style={{ textAlign: 'center', display: 'block', marginTop: 8 }}>
									Supplier List
								</Button>
                            </React.Fragment>)
                        : null}
                    </Col>
                </Row>
                <Row><Col><br /><br /></Col></Row>
            </React.Fragment >

        )
    }
}

export default Search;



// WEBPACK FOOTER //
// ./src/areas/companyManagement/connectToSponsors/Search.js